
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2310_7908)"}},[_c('rect',{attrs:{"width":"24","height":"24","rx":"12","fill":"#FF7900"}}),_c('path',{attrs:{"d":"M6.81286 8.8V7.252H9.70486V16H7.97686V8.8H6.81286ZM11.8925 14.104C12.6605 13.464 13.2725 12.932 13.7285 12.508C14.1845 12.076 14.5645 11.628 14.8685 11.164C15.1725 10.7 15.3245 10.244 15.3245 9.796C15.3245 9.388 15.2285 9.068 15.0365 8.836C14.8445 8.604 14.5485 8.488 14.1485 8.488C13.7485 8.488 13.4405 8.624 13.2245 8.896C13.0085 9.16 12.8965 9.524 12.8885 9.988H11.2565C11.2885 9.028 11.5725 8.3 12.1085 7.804C12.6525 7.308 13.3405 7.06 14.1725 7.06C15.0845 7.06 15.7845 7.304 16.2725 7.792C16.7605 8.272 17.0045 8.908 17.0045 9.7C17.0045 10.324 16.8365 10.92 16.5005 11.488C16.1645 12.056 15.7805 12.552 15.3485 12.976C14.9165 13.392 14.3525 13.896 13.6565 14.488H17.1965V15.88H11.2685V14.632L11.8925 14.104Z","fill":"white"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2310_7908"}},[_c('rect',{attrs:{"width":"24","height":"24","fill":"white"}})])])])
          )
        }
      }
    